"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedProductEditorTableContainer = exports.ProductEditorTableContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const classify_modal_1 = require("./classify-modal");
const table_styles_1 = require("./table.styles");
const tabs_1 = require("./tabs/tabs");
const classify_modal_2 = require("../table/classify-modal");
const taxonomy_class_dropdown_1 = __importDefault(require("../taxonomy-class-dropdown"));
const hooks_1 = require("../../../hooks");
const icons_1 = require("../../../icons");
const localization_1 = require("../../../localization");
const chips_1 = require("../../chips");
const components_1 = require("../../components");
const hooks_2 = require("../../hooks");
const store_1 = require("../../../store");
const State = __importStar(require("../../../store/state"));
const LS_ACTIVE_COLUMNS = 'ProductEditor_Table_ActiveColumns';
const SEARCHABLE_FIELDS = ['title', 'description', 'proprietaryId'];
const ProductEditorTableContainer = ({ lastSelectedRowId, setLastSelectedRowId, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const selectedOrganizationsIds = (0, store_1.useSelectedOrganizationsIdsSelector)();
    const [currentOrganizationsIds] = selectedOrganizationsIds;
    const [allTotal, setAllTotal] = (0, react_1.useState)(0);
    const [classifiedTotal, setClassifiedTotal] = (0, react_1.useState)(0);
    const [unclassifiedTotal, setUnclassifiedTotal] = (0, react_1.useState)(0);
    const [activeTab, setActiveTab] = (0, react_1.useState)(0 /* TABS.Unclassified */);
    const [isClassifyModalOpen, setIsClassifyModalOpen] = (0, react_1.useState)(false);
    const { handleSearch, searchFilter, searchQuery } = (0, hooks_2.useTableSearch)(SEARCHABLE_FIELDS, setLastSelectedRowId);
    const { sortParams, handleSort } = (0, hooks_2.useTableSort)();
    const { activeFilter, getFilters } = (0, hooks_2.useFilter)({ activeTab, searchFilter });
    const setTotalCount = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const { filter, unclassifiedFilter } = getFilters();
        if (currentOrganizationsIds) {
            try {
                const [allTotal, unclassifiedTotal] = yield Promise.all([client.products.getTotal(filter), client.products.getTotal(unclassifiedFilter)]);
                setAllTotal(allTotal);
                setUnclassifiedTotal(unclassifiedTotal);
                setClassifiedTotal(allTotal - unclassifiedTotal);
            }
            catch (_a) {
                addError(t({ key: 'PRODUCT_EDITOR_TABLE_TABS' }));
            }
        }
        else {
            setAllTotal(0);
            setClassifiedTotal(0);
            setUnclassifiedTotal(0);
        }
    }), [client.products, getFilters, currentOrganizationsIds]);
    const { currentPage, rowsPerPage, handlePageChange, handleRowsPerPageChange, } = (0, hooks_2.useTablePagination)(activeFilter, setLastSelectedRowId);
    const { isLoading, products } = (0, hooks_2.useLoadProducts)({
        currentPage,
        filter: activeFilter,
        rowsPerPage,
        setTotalCount,
        sortParams,
    });
    const handleChipsClear = () => {
        setLastSelectedRowId(null);
    };
    const handleTabChange = (0, react_1.useCallback)((_, newValue) => {
        setActiveTab(newValue);
    }, [activeTab]);
    const { activeColumns, columns, defaultColumns, handleSetActiveColumns, } = (0, hooks_2.useRefineModal)({ lsKey: LS_ACTIVE_COLUMNS });
    const tableColumns = (0, hooks_2.useTableColumns)({ activeColumns });
    const getAdditionalRows = (0, react_1.useCallback)((product) => ({
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS]: react_1.default.createElement(table_styles_1.StyledAutocompleteCell, { key: "class", align: "left", size: "small" }, react_1.default.createElement(taxonomy_class_dropdown_1.default, { clearOnBlur: true, product: product })),
    }), []);
    const getTableRows = (0, hooks_2.useTableRows)({ activeColumns, getAdditionalRows });
    const total = (0, store_1.useProductsTotal)();
    const { handleAllProductsSelect, handleProductSelect, selectedProductsCount, selectedProductsForPage, } = (0, hooks_2.useSelectedProducts)({
        lastSelectedRowId,
        setLastSelectedRowId,
        products,
    });
    const handleClassify = (0, react_1.useCallback)(() => {
        setLastSelectedRowId(null);
        dispatch((0, store_1.clearAllSelectedProducts)());
    }, [dispatch, setLastSelectedRowId]);
    (0, react_1.useEffect)(() => {
        setLastSelectedRowId(null);
        dispatch((0, store_1.setIsExclusionModeOn)(false));
        dispatch((0, store_1.clearAllSelectedProducts)());
    }, [activeFilter, dispatch, setLastSelectedRowId]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(classify_modal_2.ClassifyModalContext.Provider, { value: { activeTab, searchFilter } }, react_1.default.createElement(classify_modal_1.ClassifyModal, { isOpen: isClassifyModalOpen, onClassify: handleClassify, onClose: () => setIsClassifyModalOpen(false), activeFilter: activeFilter, selectedProductsCount: selectedProductsCount })), react_1.default.createElement(tabs_1.ProductEditorTableTabs, { activeTab: activeTab, allTotal: allTotal, classifiedTotal: classifiedTotal, unclassifiedTotal: unclassifiedTotal, onTabChange: handleTabChange }), react_1.default.createElement(table_styles_1.StyledTableToolbar, null, react_1.default.createElement(table_styles_1.StyledBulkClassifyButtonWrapper, null, react_1.default.createElement(ui_components_1.Button, { color: "primary", disabled: !selectedProductsCount, title: t({ key: 'BULK_CLASSIFY' }), variant: "outlined", onClick: () => setIsClassifyModalOpen(true) })), react_1.default.createElement(components_1.ProductEditorTableSearch, { searchQuery: searchQuery, onSearch: handleSearch }), react_1.default.createElement(components_1.RefineModalButton, { activeColumns: activeColumns, columns: columns, defaultColumns: defaultColumns, setActiveColumns: handleSetActiveColumns }, react_1.default.createElement(icons_1.FilterIcon, { width: "10px", height: "10px", fill: ui_components_1.baseColors.black }), react_1.default.createElement("span", null, (t({ key: 'REFINE' })).toUpperCase())), react_1.default.createElement(components_1.TimezoneLabel, null)), react_1.default.createElement(table_styles_1.StyledChipsWrapper, null, react_1.default.createElement(chips_1.ChipsContainer, { onClear: handleChipsClear })), react_1.default.createElement(components_1.TableSelectionButtons, { setLastSelectedRowId: setLastSelectedRowId }), react_1.default.createElement(components_1.ProductEditorTable, { columns: tableColumns, currentPage: currentPage, getTableRows: getTableRows, isLoading: isLoading, onPageChange: handlePageChange, onRowsPerPageChange: handleRowsPerPageChange, onSort: handleSort, products: products, rowsPerPage: rowsPerPage, sortParams: sortParams, total: total, onSelect: handleProductSelect, onSelectAll: handleAllProductsSelect, selectedRows: selectedProductsForPage })));
};
exports.ProductEditorTableContainer = ProductEditorTableContainer;
exports.MemoizedProductEditorTableContainer = react_1.default.memo(exports.ProductEditorTableContainer);
exports.default = exports.MemoizedProductEditorTableContainer;
